const actionTypes = {
  FetchOrder: 'FETCH_ORDER',
  OrderUpdated: 'ORDER_UPDATED',
};

export default actionTypes;
